import React, {useEffect, useState} from "react";
import styles from "./DesignsGallery.module.scss";
import wrapStyles from "../CustomWraps.module.scss";
import { designs } from "../CustomWraps.data";
import {buttonClick, chunkArray} from "utils/Helpers";
import {useDispatch, useSelector} from "react-redux";

const DesignsGallery = (props) => {

    const wrapSelection = useSelector(state => state.wrapSelection);
    const windowData = useSelector(state => state.window);
    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch()
    const [rowCount, setRowCount] = useState(9); //max for now, not enough to load more
    const [colCount, setColCount] = useState(windowData.width > 768 ? 4 : 3);

    useEffect(()=>{
        setColCount(windowData.width > 768 ? 4 : 3)
    }, [windowData])


    function buildRows(){
        let rows = [];
        chunkArray(designs,colCount).forEach((designGroup, groupIndex) => {
            if(rowCount >= groupIndex+1){
                rows.push(
                    <ul key={groupIndex}>
                        {designGroup.map((design, i) => (
                            <li tabIndex={!accessible.modalOpen ? 0 : null} role={!accessible.modalOpen ? 'button' : null} aria-label={`Design by ${design.name}, ${design.statement}`} onKeyDown={buttonClick} key={i} onClick={(e) => selectDesign(design)}>
                                <div className={`${styles.design} ${wrapSelection.design === design ? styles.selected : ''}`}
                                     style={{backgroundImage: `url(${design.swatch})`}}/>
                                <figcaption>{design.name}</figcaption>
                            </li>
                        ))}
                    </ul>
                )
            }
        })
        return rows;
    }

    function loadMoreButton(){
        if((rowCount * colCount) < designs.length){
            return(
                <div className={styles.loadMore} onClick={()=>setRowCount(rowCount+1)}>Check out more</div>
            )
        }
    }

    function selectDesign(design) {

        dispatch({ type: "SET_WRAP_SELECTION",
            payload: {
                ...wrapSelection,
                design: design
            }
        });

    }

    function ariaHidden (){
        return (wrapSelection.product && !wrapSelection.design) || (!wrapSelection.product && wrapSelection.design)
    }

    return (
        <div aria-hidden={ariaHidden()} className={`${wrapStyles.wrapsBlade}`}>

            <h4 tabIndex={-1} ref={props.titleFocus}>Browse designs</h4>
            <div className={`${styles.browseDesigns}`}>
                {buildRows()}
                {loadMoreButton()}
            </div>


        </div>
    )

}

export default DesignsGallery;
